
















import {Component, Prop} from 'vue-property-decorator';
import JdhInputArea from "@/design-system/forms/shared/JdhInputArea.vue"
import {mixins} from "vue-class-component"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhFilterStructure from "@/design-system/forms/shared/JdhFilterStructure.vue"
import JdhAttachedModalPopup from "@/design-system/shared/JdhAttachedModalPopup.vue"

/**
 * @status stable
 * @published 5.0.0
 * @changelog 5.0.0 Published with form revamp.
 */
@Component({
    components: {JdhAttachedModalPopup, JdhFilterStructure, JdhInputArea}
})
export default class JdsListFilter extends mixins(UniqueIdMixin) {
    @Prop() label!: string
    @Prop() value!: string

    open = false
    source: HTMLElement|null = null

    emitInput(value: string) {
        this.$emit('input', value)
    }

}
